<template>
  <v-hover v-slot:default="{ hover }" open-delay="350">
    <div
      class="p-itemArea px-2"
      @mouseover="displayAddItemBtn"
      @mouseleave="hideAddItemBtn"
    >
      <div class="p-itemArea__body">
        <heading-item
          v-if="item.variety === 'heading'"
          :item="item"
          :index="index"
          @hide-item-btn="hideAddItemBtn"
        />
        <text-item
          v-else-if="item.variety === 'text'"
          :item="item"
          :index="index"
          @hide-item-btn="hideAddItemBtn"
        />
        <point-item
          v-else-if="item.variety === 'point'"
          :item="item"
          :index="index"
          @hide-item-btn="hideAddItemBtn"
        />
        <image-item
          v-else-if="item.variety === 'image'"
          :item="item"
          :index="index"
          @hide-item-btn="hideAddItemBtn"
        />
        <external-link-item
          v-else-if="item.variety === 'external_link'"
          :item="item"
          :index="index"
          @hide-item-btn="hideAddItemBtn"
        />
        <list-item
          v-else-if="item.variety === 'list'"
          :item="item"
          :index="index"
          @hide-item-btn="hideAddItemBtn"
        />
        <quotation-item
          v-else-if="item.variety === 'quotation'"
          :item="item"
          :index="index"
          @hide-item-btn="hideAddItemBtn"
        />
        <internal-link-item
          v-else-if="item.variety === 'internal_link'"
          :item="item"
          :index="index"
          @hide-item-btn="hideAddItemBtn"
        />
        <embedding-item
          v-else-if="item.variety === 'embedding'"
          :item="item"
          :index="index"
          @hide-item-btn="hideAddItemBtn"
        />
        <product-introduction-item
          v-else-if="item.variety === 'product_introduction'"
          :item="item"
          :index="index"
          @hide-item-btn="hideAddItemBtn"
        />
        <html-item
          v-else-if="item.variety === 'html'"
          :item="item"
          :index="index"
          @hide-item-btn="hideAddItemBtn"
        />
        <character-item
          v-else-if="item.variety === 'character'"
          :item="item"
          :index="index"
          @hide-item-btn="hideAddItemBtn"
        />
        <table-item
          v-else-if="item.variety === 'table_item'"
          :item="item"
          :index="index"
          @hide-item-btn="hideAddItemBtn"
        />
        <button-item
          v-else-if="item.variety === 'button'"
          :item="item"
          :index="index"
          @hide-item-btn="hideAddItemBtn"
        />
        <banner-item
          v-else-if="item.variety === 'banner'"
          :item="item"
          :index="index"
          @hide-item-btn="hideAddItemBtn"
        />
        <html-table-item
          v-else-if="item.variety === 'html_table'"
          :item="item"
          :index="index"
          @hide-item-btn="hideAddItemBtn"
        />
      </div>
      <div class="p-itemArea__btns">
        <template v-if="hover && displayAddItemBtnFlag">
          <item-add-btn-group :previous-index="index" />
          <sorting-buttons-group :index="index" :uuid="item.uuid" />
          <copy-item-btn :item="item" :index="index" />
        </template>
      </div>
    </div>
  </v-hover>
</template>

<script>
import HeadingItem from '../items/HeadingItem'
import TextItem from '../items/TextItem'
import PointItem from '../items/PointItem'
import ImageItem from '../items/ImageItem'
import ExternalLinkItem from '../items/ExternalLinkItem'
import InternalLinkItem from '../items/InternalLinkItem'
import ListItem from '../items/ListItem'
import QuotationItem from '../items/QuotationItem'
import EmbeddingItem from '../items/EmbeddingItem'
import ProductIntroductionItem from '../items/ProductIntroductionItem'
import HtmlItem from '../items/HtmlItem'
import CharacterItem from '../items/CharacterItem'
import TableItem from '../items/TableItem'
import ButtonItem from '../items/ButtonItem'
import { mapState } from 'vuex'
import ItemAddBtnGroup from '../parts/ItemAddBtnGroup'
import SortingButtonsGroup from '../parts/SortingButtonsGroup'
import CopyItemBtn from '../parts/CopyItemBtn'
import BannerItem from '../items/BannerItem'
import HtmlTableItem from '../items/HtmlTableItem'

export default {
  name: 'Item',
  components: {
    HtmlTableItem,
    BannerItem,
    HeadingItem,
    TextItem,
    PointItem,
    ImageItem,
    ExternalLinkItem,
    InternalLinkItem,
    ListItem,
    QuotationItem,
    EmbeddingItem,
    ProductIntroductionItem,
    HtmlItem,
    CharacterItem,
    TableItem,
    ItemAddBtnGroup,
    SortingButtonsGroup,
    CopyItemBtn,
    ButtonItem
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: true
    }
  },
  data: function () {
    return {
      displayAddItemBtnFlag: false
    }
  },
  computed: {
    ...mapState({
      editingItemIndex: (state) => state.PostEditor.editingItemIndex
    })
  },
  methods: {
    displayAddItemBtn: function () {
      if (this.isEditingItem()) {
        this.displayAddItemBtnFlag = true
      }
    },
    hideAddItemBtn: function () {
      this.displayAddItemBtnFlag = false
    },
    isEditingItem () {
      return this.editingItemIndex == null
    }
  }
}
</script>

<style scoped>
.p-itemArea__body:hover {
  background: #f7f7f7;
  cursor: pointer;
}

.p-itemArea__btns {
  min-height: 40px;
  display: flex;
  flex-wrap: wrap;
}

.p-itemArea__btns:hover {
  background: #f7f7f7;
  cursor: pointer;
}
</style>
